import {
  createContext,
  useContext,
  useEffect,
  useState,
  type ReactNode,
} from "react";

const SelectionContext = createContext<{
  selected: string | null;
  select: (key: string | null) => void;
}>({ selected: null, select: () => {} });

export function SelectionProvider({ children }: { children: ReactNode }) {
  const [selected, select] = useState<string | null>(null);
  useEffect(() => {
    const outside = (event: PointerEvent) => {
      if (
        !(event.target instanceof Element) ||
        !event.target.closest("[data-selection-key]")
      )
        select(null);
    };
    const escape = (event: KeyboardEvent) => {
      if (
        event.key === "Escape" &&
        !(event.target as Element).closest(
          "input,textarea,[contenteditable=true],[role=dialog]",
        )
      )
        select(null);
    };
    document.addEventListener("pointerdown", outside, true);
    document.addEventListener("keydown", escape);
    return () => {
      document.removeEventListener("pointerdown", outside, true);
      document.removeEventListener("keydown", escape);
    };
  }, []);
  return (
    <SelectionContext.Provider value={{ selected, select }}>
      {children}
    </SelectionContext.Provider>
  );
}

export const useSelection = () => useContext(SelectionContext);
